// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import QRCode from '../../_common/api/QRCode';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Cart from '../../_common/Cart';
import Button from '../../_common/form/Button';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import airPAY from '../../../assets/images/airPAY.png';
import CountDown from '../../_common/CountDown';
import styled from 'styled-components';
import Loading from '../../_common/Loading';
import { HamQuest } from '../../../App';
import { HasFeature, Features } from '../../_common/RequireFeature';

const PaddedDiv = styled.div`
    padding: 0.5em 0;
`;

const AirPay = () => {
    const { state: {
        active_user,
        site_config
    } } = useGlobalState();

    const { search } = useLocation();
    const showAppCreditOption = new URLSearchParams(search).get('appCredit') === 'true';

    const eGiftEnabled = HasFeature(Features.AppCredit);
    const noCardOnFile = !active_user.payment || !active_user.payment.onFile;
    const noGiftBalance = !active_user.account || active_user.account.giftBalance === 0;
    const hasGiftBalance = active_user.account && active_user.account.giftBalance !== 0;
    const needsCardToUseAirPay = noCardOnFile && noGiftBalance;
    const useGiftBalance = eGiftEnabled && hasGiftBalance && showAppCreditOption;

    const [token, setToken] = useState(false)

    const generateToken = () => {
        setToken(false);
        HamQuest.post(QuestRoute.tempToken, {
            TempIdType: useGiftBalance ? 'GiftBalanceTempToken' : 'TempToken'
        })
            .then((res) => {
                if (!res.tempId) throw res.error;
                setToken(res.tempId);
            })
            .catch(ex => {
                console.log(ex);
                Modal.Show({
                    type: 'error',
                    title: 'Unable to Generate Token',
                    body: ex.blob || 'Sorry, something went wrong. Please try again.'
                });
            });
    }

    useEffect(() => {
        if (needsCardToUseAirPay) return;
        generateToken();
    }, [needsCardToUseAirPay, useGiftBalance])

    const handleAddCardToAccount = async () => {
        try {
            await Cart.AddCardToAccount();
        } catch (error) {
            if (
                error?.message !== 'Email verification required before adding a card.' &&
                error?.message !== 'Card tokenization cancelled.'
            ) {
                console.error('Unable to add card to account', error);
            }
        }
    }

    return (
        <Card title={site_config.airPayName ?? 'AirPay'} icon='QRcode'>

                {needsCardToUseAirPay ?
                    <>
                        <img src={airPAY} alt='AirPAYimg' />
                        <br />
                        <PaddedDiv>
                            <b>{site_config.airPayName ?? 'AirPay'}</b> gives you a quick and easy way to purchase services at our {site_config.companyName} locations. It's much like swiping a credit card only more secure! <br />
                            Once you register your credit/debit card with is, simply tap the {site_config.airPayName ?? 'AirPay'} button whenever you are ready to buy a wash. <br />
                            A unique code will be generated for you, which can then be scanned at the barcode reader of any of our kiosks. <br />
                            Your payment method will be charged and your service will then begin! A receipt is automatically emailed to you with every transaction.
                        </PaddedDiv>
                        <Button onClick={handleAddCardToAccount}>Set Up {site_config.airPayName ?? 'AirPay'}</Button>
                    </> :
                    token ?
                        <>
                            <QRCode data={token} />
                            <CountDown type='bar' time={30} callback={() => setToken(null)} />
                            <PaddedDiv>
                                {useGiftBalance
                                    ? 'Your App Credit balance will be used for this transaction.'
                                    : "It's much like swiping a credit card only more secure! The card you have registered with us will be charged for this transaction."}
                            </PaddedDiv>
                        </> : token === false ?
                            <Loading /> :
                            <>
                                <PaddedDiv>Token expired. Please generate a new token to use {site_config.airPayName ?? 'AirPay'}.</PaddedDiv>
                                <Button onClick={() => generateToken()}>Generate a new Token</Button>
                            </>
                }
                {noCardOnFile && hasGiftBalance ? 
                <>
                    <PaddedDiv>
                        <b>Note:</b> You do not have a credit/debit card on file. Add one to make sure you can use AirPAY when your gift card runs low.
                    </PaddedDiv>
                    <Button onClick={handleAddCardToAccount}>Add a Card</Button>
                </> : null
            }
        </Card>
    );
}

export default AirPay;